import { InboxOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { message } from 'antd';
import Upload, { RcFile } from 'antd/lib/upload';
import React, { useCallback } from 'react';

const { Dragger } = Upload;

interface IProps {
  handleUpload: (file: RcFile) => void;
}

const DocumentDropZone: React.FC<IProps> = ({ handleUpload }) => {
  const beforeUpload = useCallback((file: File) => {
    const isLesserThen10MB = file.size / 1024 / 1024 < 10;
    if (!isLesserThen10MB) {
      message.error(`${L('File size exceeds the maximum limit of 10 MB!')}`);
    }
    return isLesserThen10MB;
  }, []);

  return (
    <Dragger
      beforeUpload={beforeUpload}
      showUploadList={false}
      customRequest={(e) => handleUpload(e.file as RcFile)}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text" style={{ padding: '0px 20px' }}>
        {L('Click or drag file to this area to upload')}
      </p>
      <p className="ant-upload-hint">
        {L('Support for a single or bulk upload. Strictly prohibit from')}
      </p>
      <p className="ant-upload-hint">{L('uploading company data or other banned files')}</p>
    </Dragger>
  );
};

export default DocumentDropZone;
